export enum CurrencyCodeEnum {
    EUR = "EUR",
    GBP = "GBP",
    USD = "USD"
}